module.exports = __webpack_public_path__ + "static/media/icon_41.fd39a603.svg";